export const jobDescriptionOptions = [
  'Barber',
  'Builder',
  'Carpenter',
  'Chauffeur',
  'Childcare',
  'Copywriter',
  'Delivery Driver/Rider',
  'Driving Instructor',
  'Electrician',
  'Event Co-ordinator',
  'Freelance Writer',
  'Graphic Designer',
  'Hairdresser',
  'Handyman',
  'Joiner',
  'Labourer',
  'Landscape Gardner',
  'Make-up artist',
  'Music Teacher',
  'Nail Technician',
  'Personal Trainer',
  'Photographer',
  'Plasterer',
  'Plumber',
  'Private Hire Driver',
  'Project Manager',
  'Slater',
  'Social Media Manager',
  'Taxi Driver',
  'Tiler',
  'Tutor',
  'UX Designer',
  'Video Editor',
  'Videographer',
  'Virtual Assistant',
  'Web Designer',
  'Web Developer',
  'Other'
];